import { render, staticRenderFns } from "./topic_detail.vue?vue&type=template&id=8cc600ea&scoped=true"
import script from "./topic_detail.vue?vue&type=script&lang=js"
export * from "./topic_detail.vue?vue&type=script&lang=js"
import style0 from "./topic_detail.vue?vue&type=style&index=0&id=8cc600ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc600ea",
  null
  
)

export default component.exports